export const customerValidate = (dtStart, dtEnd, i18n) => {
  const messages = {}
  if ((dtStart && !new Date(dtStart).getTime()) || (dtEnd && !new Date(dtEnd).getTime()))
    messages.DATE = i18n.t('validate.customer.msgInvalidDateFormat')
  if (dtStart && dtEnd && new Date(dtEnd) < new Date(dtStart)) {
    messages.InvalidDtEnd = i18n.t('validate.customer.msgDtEndInvalid')
  }
  return messages
}
